/* ============================================================
   MICTLÁN — Puente entre Amatora y el carrito de Horizon
   ============================================================
   Los botones de las tarjetas usan `amatora-add-to-cart`, que hace su
   propio POST a /cart/add.js. El producto entra bien, pero Horizon no se
   entera: ni el contador del ícono ni el panel del carrito se refrescan,
   porque el theme actualiza esos nodos al procesar SUS propias respuestas.

   Qué se probó antes de llegar a esto:
   · Reemitir `shopify:cart:lines-update` — el contador no reaccionó.
   · Reemplazar secciones por id — los ids llevan prefijos dinámicos del
     template (`shopify-section-sections--123__header_section`).
   · Llamar a `cart-drawer-component.open()` — no expone método público.

   Lo que sí funciona: pedir el HTML nuevo con la Section Rendering API y
   sustituir los componentes buscándolos por su etiqueta (que sí es
   estable), y después abrir el panel con el botón del encabezado, que
   trae `on:click="#cart-drawer/toggle"`.
   ============================================================ */
(function () {
  'use strict';

  var SECCIONES = 'cart-drawer-section,header';
  var BOTON_CARRITO = 'button[aria-controls="cart-drawer"]';

  /** Sustituye un componente por su versión recién renderizada. */
  function sustituir(htmlSeccion, etiqueta) {
    if (!htmlSeccion) return false;

    var temporal = document.createElement('div');
    temporal.innerHTML = htmlSeccion;

    var nuevo = temporal.querySelector(etiqueta);
    var actual = document.querySelector(etiqueta);
    if (!nuevo || !actual) return false;

    actual.replaceWith(nuevo);
    return true;
  }

  /** Abre el panel del carrito por el mismo camino que un cliente. */
  function abrirCarrito() {
    if (document.querySelector('dialog[open]')) return;

    var boton = document.querySelector(BOTON_CARRITO);
    if (!boton) return;

    // Es un toggle: si ya figura abierto, otro clic lo cerraría.
    if (boton.getAttribute('aria-expanded') === 'true') return;

    boton.click();
  }

  function refrescarYAbrir() {
    fetch('/?sections=' + SECCIONES, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (datos) {
        if (!datos) return;

        sustituir(datos['cart-drawer-section'], 'cart-drawer-component');
        sustituir(datos['header'], 'cart-icon');
      })
      .catch(function () {
        /* El producto ya quedó agregado; se verá al entrar al carrito. */
      })
      .then(function () {
        // Un par de frames para que los componentes nuevos se enganchen
        // antes de pedirles que se muestren.
        requestAnimationFrame(function () {
          requestAnimationFrame(abrirCarrito);
        });
      });
  }

  // --- Origen 1: el botón circular de la tarjeta (Amatora) ---
  document.addEventListener('amatora:cart:added', refrescarYAbrir);

  // --- Origen 2: el botón nativo de la ficha y la compra rápida ---
  // Horizon avisa con el evento estándar, pero su panel solo se abre solo si
  // el carrito ya figuraba con contenido en el DOM; recién agregado, todavía
  // no. Por eso también se engancha acá.
  document.addEventListener('shopify:cart:lines-update', function (evento) {
    if (evento && evento.action && evento.action !== 'add') return;

    // El theme ya refresca lo suyo en este caso: basta con mostrarlo.
    setTimeout(abrirCarrito, 500);
  });
})();
